import React from 'react';
import { BANNER_WIDGET_LAYOUT_TYPE_V2, BannerWidgetDetailV2 } from '../../../../../../types/widget';
import BannerWidgetSwipeLayout from './BannerWidgetSwipeLayout';
import { BannerWidgetSwipeLayoutDetail } from './BannerWidgetSwipeLayout/BannerWidgetSwipeLayout';
import BannerWidgetGridLayout from './BannerWidgetGridLayout';
import { BannerWidgetGridLayoutDetail } from './BannerWidgetGridLayout/BannerWidgetGridLayout';
import BannerWidgetScrollLayout from './BannerWidgetScrollLayout';
import { BannerWidgetScrollLayoutDetail } from './BannerWidgetScrollLayout/BannerWidgetScrollLayout';
import WidgetPreviewHeader from '../../../common/components/WidgetPreviewHeader';
import Modal from '../../../../../../components/Modal';

interface BannerWidgetPreviewModalProps {
  isOpen: boolean;
  detail: BannerWidgetDetailV2;
  onClose: () => void;
}

const BannerWidgetPreviewModal = (props: BannerWidgetPreviewModalProps) => {
  const { isOpen, detail, onClose } = props;

  const getLayoutView = (detail: BannerWidgetDetailV2) => {
    switch (detail.layoutType) {
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5:
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5:
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN:
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_NO_MARGIN:
        return <BannerWidgetSwipeLayout detail={detail as BannerWidgetSwipeLayoutDetail} />;
      case BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_1X2:
      case BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_2X2:
        return <BannerWidgetGridLayout detail={detail as BannerWidgetGridLayoutDetail} />;
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1:
        return <BannerWidgetScrollLayout detail={detail as BannerWidgetScrollLayoutDetail} />;
    }
  };

  return (
    <Modal
      title={'위젯 미리보기'}
      wrapClassName="widget-preview-modal-wrapper"
      isOpen={isOpen}
      width={375}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText="확인"
      onOk={onClose}
      onClose={onClose}
    >
      <WidgetPreviewHeader mainTitle={detail.mainTitle} subTitle={detail.subTitle} />
      {isOpen && getLayoutView(detail)}
    </Modal>
  );
};

export default BannerWidgetPreviewModal;
